module.exports = __webpack_public_path__ + "static/media/energy_worldnet.f294062f.svg";